import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, MatTableDataSource, MatSort} from '@angular/material';
import {ClipboardService} from 'ngx-clipboard';
import {AccessControlService} from 'src/app/services/access-control.service';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-client-application-list',
  templateUrl: './client-application-list.component.html',
  styleUrls: ['./client-application-list.component.css']
})
export class ClientApplicationListComponent implements OnInit {
  displayedColumns: string[] = ['application_name', '_id', 'application_description', 'auth_type', 'Actions'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  is_copied = false;
  dataSource: MatTableDataSource<any>;
  isLoading: boolean;
  clientId: any;
  noData: any;

  constructor(private accesscontrolService: AccessControlService, private _clipboardService: ClipboardService) {
  }

  ngOnInit() {
    this.clientId = localStorage.getItem('org_id')
    this.getapps()
  }

  getapps() {
    this.isLoading = true
    this.accesscontrolService.getClient(this.clientId, "0").subscribe((res: any) => {
        this.dataSource = new MatTableDataSource<any>(res.data.applications);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false
      })
  }

  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  copyToClipboard(action) {
    this.is_copied = this._clipboardService.copyFromContent(action);
    setTimeout(() => {
      this.is_copied = false
    }, 700);
  }

  closeAlert() {
    this.is_copied = false
  }

}
